// src/components/Sticker.js

import React from 'react';
import './Sticker.css';


const Sticker = ({ id, src, onClick }) => (
  <img
    src={src}
    
    onClick={(e) => onClick(id)}
    className="draggable-sticker"
    alt={`Sticker ${id}`}
  />
);

export default Sticker;



